import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hutchinsonConfig } from "./data";

export default function HutchinsonPage() {
  return <CityPageTemplate config={hutchinsonConfig} />;
}